import { IconButton } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

import { ChipContainer, ChipLabel } from './SelectionChip.styles';

import type { SelectionChipProps } from './SelectionChip.types';

/**
 * One applied filter: an icon, its label and ✕ to remove it. The look of every chip beside the picker —
 * people and plan units, and whatever else a page lists with them (the overview's activities).
 */
const SelectionChip = ({
  icon,
  label,
  removeLabel,
  onRemove
}: SelectionChipProps) => {
  'use memo';

  return (
    <ChipContainer>
      {icon}
      <ChipLabel>{label}</ChipLabel>
      <IconButton size="small" onClick={onRemove} aria-label={removeLabel}>
        <Icon type="xmark" fontSize="small" />
      </IconButton>
    </ChipContainer>
  );
};

export default SelectionChip;
